import axios from "axios";
import { recaptchaActions } from "../data/constant";
import { API_BASE_URL } from "../utils/config";

const { REACT_APP_RECAPTCHA_V3_ENABLED } = process.env;

const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes

// Helper function to generate a fresh reCAPTCHA token
const generateRecaptchaToken = async (action) => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
  await new Promise((resolve) => {
    window.grecaptcha.ready(resolve);
  });
  return await window.grecaptcha.execute(siteKey, { action: action });
};

export const callToLoadAnalytics = async () => {
    // Check cache (persists across refreshes)
  try {
    const cached = sessionStorage.getItem('analytics_config');
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_DURATION) {
        return data;
      }
    }
  } catch (e) {}
  if (REACT_APP_RECAPTCHA_V3_ENABLED !== "true") {
    return true;
  }
  try {
    const recaptcha = await generateRecaptchaToken(recaptchaActions?.loadAnalytics);
    const response = await axios.get(
      `${API_BASE_URL}/meta/v1/should-load-analytics`,
      {
        headers: {
          recaptchatoken: recaptcha,
        },
      }
    );

    // Cache for 30 minutes
    sessionStorage.setItem('analytics_config', JSON.stringify({
      data: response.data,
      timestamp: Date.now()
    }));

    return response.data;
  } catch (error) {
    console.warn('Analytics config failed:', error?.message || error);
    return true;
  }
};

const getAuthorizationHeader = () => {
  const token = localStorage.getItem("consumerSite_token");
  return token ? `Bearer ${token}` : "";
};

const getPartnerSiteHeaders = () => {
  const partnerSiteId = JSON.parse(sessionStorage.getItem("partnerSiteId"));
  return {
    "x-partner-id": partnerSiteId?.uid ?? 0,
    "x-site-id": partnerSiteId?.siteId ?? 0,
  };
};

export const getRecallSummary = async (payload) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/edmunds/v1/recallsummary/vin/${payload?.vin}`
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getRecallSummary" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};

export const getPartner = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/product/v1/partner`,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getPartner" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
export const getZipcode = async (payload) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/meta/v1/zip-info/${payload?.zipCodes}`
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getZipcode" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
export const getVinReport = async (payload) => {
  let recaptchaToken = null;
  try {
    recaptchaToken = await generateRecaptchaToken(recaptchaActions?.vinSearch);

    const response = await axios.get(
      `${API_BASE_URL}/meta/v1/summary/${payload?.vin}`,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          recaptchatoken: recaptchaToken,
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getVinReport" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
export const getPlateStateReport = async (payload) => {
  let plateRecaptchaToken = null;
  try {
    plateRecaptchaToken = await generateRecaptchaToken(
      recaptchaActions?.plateSearch
    );

    const response = await axios.get(
      `${API_BASE_URL}/meta/v1/summary/plate/${payload?.plate}/state/${payload?.state}`,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          recaptchatoken: plateRecaptchaToken,
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getPlateStateReport" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
export const getViewFullReport = async (payload) => {

  try {
    const response = await axios.get(
      `${API_BASE_URL}/vin/v1/fullreport/${payload?.vin}/type/${payload.fileType}?isOwner=${payload.isOwner}`,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          // recaptchatoken: plateRecaptchaToken,
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getViewFullReport" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting View Full Report:", error);
    throw error.response?.data || error.message || error;
  }
};
export const getFloodRiskReport = async (payload) => {
  let floodRiskToken = null;
  try {
    floodRiskToken = await generateRecaptchaToken(
      recaptchaActions?.floodRiskCheck
    );

    const response = await axios.get(
      `${API_BASE_URL}/floodriskindicators/v1/vin/${payload?.vin}`,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          recaptchatoken: floodRiskToken,
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getFloodRiskReport" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
export const getRecallReport = async (payload) => {
  let recallReport = null;
  try {
    recallReport = await generateRecaptchaToken(recaptchaActions?.recallCheck);

    const response = await axios.get(
      `${API_BASE_URL}/edmunds/v1/recallsummary/vin/${payload?.vin}`,
      {
        headers: {
          Authorization: getAuthorizationHeader(),
          recaptchatoken: recallReport,
          ...getPartnerSiteHeaders(),
        },
      }
    );
    return { response: { data: response.data, status: response.status, statusText: response.statusText }, API_Name: "getRecallReport" };
  } catch (error) {
    // Handle or throw the error as needed
    console.error("Error report getting members:", error);
    throw error.response?.data || error.message || error;
  }
};
